import React from 'react'
import { Button, Text, View } from './Themed'
import { useColors } from '../constants/useColors'
import type { LeagueProps, TeamProps } from '../types'
import { TeamImage } from './Jerseys'

type TeamLozengeProps = {
    team: TeamProps,
    leagues:LeagueProps[],
    is_active?:boolean,
    abbr_only?:boolean,
    onSelect: (team:TeamProps) => void
}
export const TeamLozenge = ({ team, leagues, is_active, abbr_only, onSelect }:TeamLozengeProps) => {
    const Colors = useColors();

    const league = leagues.find(l => l.league_id == team.league_id);
    
    const handleSelect = () => {
        if(!onSelect){ return }
        onSelect(team)
    }
    
    return (
        <Button float style={{ flexGrow:1, flexDirection:'row', alignItems:'center', margin:4, borderColor:is_active?Colors.text.success:undefined, borderWidth:1, padding:0, borderRadius:100 }} onPress={() => handleSelect()}>
            {abbr_only ?
            <Text size={16} theme='h2' color={is_active ? Colors.text.success: undefined}>{league?.league_name}: {team.market_name} {team.name}</Text>
            :
            <View transparent style={{ flex:1, flexDirection:'row', alignItems:'center', padding:2 }}>
                <TeamImage
                    league={league}
                    team={team}
                    size={16}
                />
                <View transparent style={{ flex:1, marginLeft:10, padding:10 }}>
                    <Text theme='h1' color={is_active ? Colors.text.success: undefined}>{team.market_name} {team.name}</Text>
                </View>
            </View>
            }
        </Button>
    )
}

export default TeamLozenge